import { getObjectPropertyValueByPath } from '_/helpers/lodashHelper'
import { eventBus } from '_/helpers/eventBus'
import { store } from '_/vuex/store'

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    vuexModule: {
      required: true,
      type: String,
    },
  },
  /**
   * Set the component's data storage
   *
   * @return  {void}
   */
  data: function() {
    return {
      published_at: null,
      isVisible: false,
    }
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    admin() {
      const getterName = `${this.vuexModule}/${this.vuexModule}`

      return this.$store.getters[getterName]
    },

    modalName() {
      return 'schedule-publishing-' + this.vuexModule
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Closes the modal
     *
     * @return  {void}
     */
    closeModal() {
      this.isVisible = false
    },

    getObjectPropertyValueByPath,

    /**
     * Fires upon publish change event
     *
     * @param   {string}  options.value  [description]
     * @return  {void}
     */
    onPublishChange({ value }) {
      this.published_at = value
    },

    /**
     * Submits form handler
     */
    onSubmit() {
      store.dispatch(`${this.vuexModule}/updateEntrySystemField`, {
        name: 'published_at',
        newValue: this.published_at,
      })
      const $form = $(this.$root.$el).find(
        `#entry-editor-form-${this.vuexModule}`
      )
      $form.submit()
      this.closeModal()
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted: function() {
    eventBus.$on('openSchedulePublishingModal', schedulePublishingModalName => {
      if (schedulePublishingModalName === this.modalName) {
        this.isVisible = true
      }
    })
  },
}
